<template>
  <b-skeleton animation="wave" class="noise-bottom" />
</template>

<script>
export default {
  name: "NoiseBottomSkeletonBox"
};
</script>
